export const getKeyFromValue =
  <T = unknown>(value: T) =>
  (obj: Record<string, T>) =>
    Object.keys(obj).find(key => Object.is(obj[key], value))
